import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BootstrapInput } from "app/components/common/BootStrapInput";
import {
	FormControl,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import {
    updateJobTypeS2
  } from "pages/Dashboard/HomeSevenScreen/7screen/redux/screen2/actions";

import { UserActivityConstants } from "api/UserActivityConstants";
import { logActivity } from "pages/Dashboard/HomeSevenScreen/7screen/redux/api/loggingAPI";

const jobQualityTypes = ["All Jobs", "H3", "High Demand", "High Skill", "High Wage"]


class JobTypeDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  handleJobTypeChange = (event) => {
    const {
      target: { value },
    } = event;
    let jobType = value;
    this.props.updateJobTypeS2(jobType)

    if (jobType === ""){
      return;
    } else {
      logActivity({
        screen: UserActivityConstants.SCREEN2.NAME,
        action_type : UserActivityConstants.ACTION_TYPES.CLICK,
        action : UserActivityConstants.SCREEN2.ACTIONS.SELECT_JOB_TYPE,
        action_target : jobType
      })
    }

  };

  
  render () {
    return (
        <div className="graph-dropdown">
        <FormControl sx={{ width: "200px", marginTop: "20px" }}>
        {/* <Typography variant="inherit" className="form-metrics-header">
            Job Type
        </Typography> */}
        <Select
        		defaultValue={"All Jobs"}
            value={this.props.jobTypeSelectedS2}
            onChange={this.handleJobTypeChange}
            input={<BootstrapInput />}
            inputProps={{ 'aria-label': 'Without label' }}
            className="select-mui"
            displayEmpty
        >
            <MenuItem disabled value="">
              <Typography variant="inherit" noWrap>
                Select a Job Type
              </Typography>
            </MenuItem>
            {jobQualityTypes.length
            ? (jobQualityTypes.map((name,i) => (
            <MenuItem
                key={i}
                value={name}
            >
                <Typography variant="inherit" noWrap>
                    {name}
                </Typography>
            </MenuItem>
            )))
            : (null)}
        </Select>
        </FormControl>
    </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    jobTypeSelectedS2:  state.Screen2Reducer.jobTypeSelectedS2
  };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        updateJobTypeS2
      },
      dispatch
    );
  }

export default connect(mapStateToProps, mapDispatchToProps)(JobTypeDropdown);
